import type { TMessages } from '@/types/TMessages'

export const messages = {
  valueUnit: '{days} {days, plural, one {день} few {дня} other {дней}}',
} satisfies TMessages
